import axios from 'axios'
import HistoryEvent from '@/dto/history/HistoryEvent'
import Paginator from '@/dto/history/Paginator'

const HistoryEventsService = {
  loadHistoryEvents(
    page: number = 1
  ): Promise<{ history: HistoryEvent[]; paginator: Paginator }> {
    return axios.get(`/admin/events`, { params: { page } }).then(response => ({
      history: response.data.history,
      paginator: response.data.paginator,
    }))
  },
}

export default HistoryEventsService
